function Content() {
  return (
    <section className="px-6 lg:px-24 py-6 lg:py-12 flex flex-col gap-2">
      <p className="text-justify text-gray-600"></p>
    </section>
  );
}

export default Content;
